


// * 获取bing 全天买量数据

import { Cascader, DatePicker, Flex, Form, Modal, Select } from "antd";
import { useTypedDispatch, useTypedSelector } from "../../../hooks/store.hook";
import { MODAL_TYPE } from "../../../store/reducers/modalSlice";
import { UserData } from "../../../utils/datatype";
import { useForm } from "antd/es/form/Form";
import dayjs from 'dayjs';
import { _message } from "../../../components/message";
import { pullBingData } from "../service";
import { useMemo, useState } from "react";
import { _setAlert } from "../../../components/alert";


export default function BingModal() {

    const { type, status } = useTypedSelector(state => state.modalReducer);
    const dispatch = useTypedDispatch();
    const { bingAccounts } = useTypedSelector(state => state.authReducer.userData as UserData);
    const [form] = useForm();
    const [loading, setLoading] = useState(false);
    const [currentAccount, setCurrentAccount] = useState<string>();



    // * 组合当前待获取bing 买量情况的账号
    const accounts = bingAccounts ? bingAccounts.map(item => {
        return {
            label: item.customerName,
            value: item.customerId,
        };
    }): [];
    // children: accountInfos[item[0]].map(item => ({ label: item, value: item })) 


    const onOk = async () => {
        setLoading(true);
        try{
            await form.validateFields();
            const values = form.getFieldsValue();
            values['queryDate'] = values['queryDate'].format('YYYY-MM-DD');
            const { data : result } = await pullBingData(values);
            setLoading(false);
            // _message.success(result.msg || '获取成功');
            if(result.code == 200) {
                _setAlert({ type: 'success', message: '获取bing数据:' + (result.msg || '成功') });
            }else{
                _setAlert({ type: 'error', message: '获取bing数据:' + result.msg });
            }
            dispatch({ type: "modal/hideModal" });
            if(!result){
                _setAlert({ type: 'error', message: '请求超时,可能是网络问题' });
            }
        }catch(err: any) {
            if(err.errorFields){
                err.errorFields.forEach((v:any) => {
                    // _message.error(v.errors.join(','))
                    _setAlert({ type: 'error', message: '获取bing数据失败:' + (v.errors.join(','))})
                })
            }
            setLoading(false);
        }
    }

    const onCancel = () => {
        dispatch({ type: "modal/hideModal"})
    }


    const filter = (inputValue: string, path: any) => {
        const isArray = Array.isArray(path);
        switch (isArray) {
            case true:
                const inputs = inputValue.split('/');
                return inputs.length > 1  ? inputs.every(input => path.some((option: { label: string, value: string }) => option.label.toLowerCase().indexOf(input.toLowerCase()) > -1)) : path.some((option: { label: string, value: string }) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
            default:
                return path.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
        }
    }


    const subAccounts = useMemo(() => {
        if(currentAccount){
            const accountMap = bingAccounts.find(item => item.customerId === currentAccount);
            return accountMap?.accounts.map(item => ({ label: item.accountName, value: item.accountId }));
        }
        return [];
    }, [currentAccount, bingAccounts])

    const onChange = (value: string) => {
        setCurrentAccount(value);
        form.setFieldValue('aid', '');
    }


    return <Modal onOk={onOk} open={status && type === MODAL_TYPE.bing} onCancel={onCancel} cancelText={'关闭'} confirmLoading={loading}>
        <Form form={form} layout="inline" initialValues={{ queryDate: dayjs() }}>
            <Flex vertical={true} gap="large">
                <Form.Item name="cid" label="主账号">
                    {/* <Cascader changeOnSelect={true} style={{ minWidth: 260 }} placeholder="主账号/子账号" showSearch={{filter}}  options={accounts} ></Cascader> */}
                    <Select listHeight={450} onChange={onChange} placeholder="主账号" style={{ minWidth: 260 }} options={accounts}>
                    </Select>
                </Form.Item>
                <Form.Item name='aid' label="子账号">
                    <Select listHeight={450} allowClear={true} showSearch={true} filterOption={filter} placeholder="子账号" style={{ minWidth: 260 }} options={subAccounts}></Select>
                </Form.Item>
                <Form.Item name="queryDate" label="日期" required={true} rules={[{ required: true, message: '日期不能为空' }]}>
                    <DatePicker style={{ minWidth: 260, marginLeft: '8ch' }}></DatePicker>
                </Form.Item>
            </Flex>
        </Form>
        <div>
            <p>说明:</p>
            <p>1:主账号必须选择</p>
            <p>2:子账号必须选择</p>
        </div>
    </Modal>
}